exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#notificaciones[data-v-2958b7f6]{background:url(\"/public/images/site/background-login.svg\");background-repeat:repeat-x;display:table;background-size:1000px;width:100%;background-position-y:top}.notificaciones[data-v-2958b7f6]{width:100%;padding-left:20px;padding-right:20px;padding-top:10px;background-color:#e9ecef;border-radius:15px;-webkit-box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75);-moz-box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75);box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75)}.commenterImage[data-v-2958b7f6]{width:48px;margin-right:5px;height:100%;float:left}.commenterImage img[data-v-2958b7f6]{width:100%;border-radius:50%}.commentText p[data-v-2958b7f6]{margin:0;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2958b7f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Notificaciones.vue
// module id = 606
// module chunks = 0